// extracted by mini-css-extract-plugin
module.exports = {"footerContainer":"WidgetBox_footerContainer__J0PfP"};